import { useMemo } from 'react';

import {
  AdConfigPlacement,
  AdServer,
  LayoutType,
  PlacementId
} from '@schibsted-nmp/advertising-shared';

export type PositionData = {
  position: number;
  placementId: PlacementId;
  containerId: string;
  adServer: AdServer;
};

export interface UseSearchPositionInstruction {
  layoutType: LayoutType;
  interminglePlacements: AdConfigPlacement[];
}

export const useSearchPositionInstruction = ({
  layoutType,
  interminglePlacements
}: UseSearchPositionInstruction): PositionData[] =>
  useMemo(
    () =>
      interminglePlacements.map(({ placementId, intermingle, adServer }) => {
        const interval = intermingle[layoutType];

        return {
          containerId: `${placementId}--container`,
          placementId,
          position: interval,
          adServer: adServer.type
        };
      }),
    [layoutType, interminglePlacements]
  );
